import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@shared/components/ui/badge';
import { useTranslation } from 'react-i18next';
import type { BatchProduct } from '../../../models/Batch';

interface ProductStrategyProps {
  product?: BatchProduct;
}

const STRATEGY_COLORS: Record<string, string> = {
  FIFO: 'bg-bg-info text-info',
  LIFO: 'bg-bg-warning text-warning',
  FEFO: 'bg-bg-success text-success',
};

export const ProductStrategy = ({ product }: ProductStrategyProps) => {
  const { t } = useTranslation('batchesModule');

  const strategy = product?.batch_type?.toUpperCase() || null;

  return (
    <section className="rounded-lg border border-card-border p-6 space-y-4">
      <h2 className="text-lg font-semibold">{t('detail.strategy.title')}</h2>

      <div className="space-y-3">
        <p className="text-xs text-complementary-text">{t('detail.strategy.active_strategy')}</p>

        {strategy ? (
          <>
            <Badge className={`text-sm font-semibold ${STRATEGY_COLORS[strategy] || ''}`}>{strategy}</Badge>

            <div className="rounded-lg bg-bg-info/30 p-3 mt-3">
              <p className="text-sm text-text">{t(`detail.strategy.${strategy}`)}</p>
            </div>

            <div className="flex items-start gap-2 mt-3">
              <FontAwesomeIcon icon={faInfoCircle} className="w-4 h-4 text-complementary-text mt-0.5" />
              <p className="text-xs text-complementary-text">{t(`detail.strategy.picking_note_${strategy}`)}</p>
            </div>
          </>
        ) : (
          <p className="text-sm text-complementary-text">{t('detail.strategy.none')}</p>
        )}
      </div>
    </section>
  );
};
